import { render, staticRenderFns } from "./single_mobile_table.vue?vue&type=template&id=948f10ca&"
import script from "./single_mobile_table.vue?vue&type=script&lang=js&"
export * from "./single_mobile_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports